import { render, staticRenderFns } from "./SupervisorUsers.vue?vue&type=template&id=7136f504"
import script from "./SupervisorUsers.vue?vue&type=script&lang=js"
export * from "./SupervisorUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports